import { useEffect, useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { onFlash } from "@/lib/flash";

export const FlashMessage = () => {
  const [msg, setMsg] = useState(null);
  const timer = useRef(null);

  useEffect(() => {
    const off = onFlash(({ message, tone }) => {
      setMsg({ message, tone });
      clearTimeout(timer.current);
      timer.current = setTimeout(() => setMsg(null), 3000);
    });
    return () => {
      off();
      clearTimeout(timer.current);
    };
  }, []);

  return (
    <AnimatePresence>
      {msg && (
        <motion.div
          key="flash"
          data-testid="flash-message"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.6 }}
          className="fixed inset-0 z-[80] flex items-center justify-center bg-black/85 px-6"
        >
          <motion.h2
            initial={{ scale: 0.9 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
            className="max-w-full break-words text-center font-display text-4xl font-black tracking-tighter sm:text-7xl"
            style={
              msg.tone === "red"
                ? { color: "#ff2222", textShadow: "0 0 24px rgba(255,0,0,0.7)" }
                : { color: "#00ff88", textShadow: "0 0 24px rgba(0,255,136,0.7)" }
            }
          >
            {msg.message}
          </motion.h2>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
